import { contactFormSchema } from './create-form.js';
import { createContactInputSchema } from './create-input.js';
export const EMPTY_CONTACT_FORM = {
    contactName: '',
    title: '',
    email: '',
    phone: '',
    preference: '',
    defaultFlag: false,
};
export function toCreateContactInput(values) {
    const parsed = contactFormSchema.parse(values);
    return createContactInputSchema.parse({
        contactName: parsed.contactName,
        title: parsed.title ?? null,
        email: parsed.email ?? null,
        phone: parsed.phone ?? null,
        preference: parsed.preference ?? null,
        defaultFlag: parsed.defaultFlag,
    });
}
//# sourceMappingURL=create-mapper.js.map